import Component from 'flarum/common/Component';
export default class MarkdownToolbar extends Component {
  view(vnode) {
    return m("div", {
      className: "MarkdownToolbar"
    }, vnode.children);
  }
}
flarum.reg.add('flarum-markdown', 'common/components/MarkdownToolbar', MarkdownToolbar);